import React, { Fragment, useEffect, useState } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import SortedTable from './helper/SortedTable';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

import styles from "./styles";
import PageHeader from "./helper/PageHeader";

import Error from './helper/Error';

const initForm = {
    lastName: '',
    firstName: '',
    county: '',
    city: '',
    companyName: '',
    fromDate: '',
    toDate: '',
}


// ********************CURRENT ISSUES******************
// A search can go through with an improperly formatted date (when not choosing from calendar)
//    Solution: Add validation to dates?



const Certificate = props => {

    // if (sessionStorage.getItem("certificateSearchState")) {
    //     state = JSON.parse(sessionStorage.getItem("certificateSearchState"));
    // } else {
    const [formState, setFormState] = useState(initForm)
    const [certificates, setCertificates] = useState([])
    const [loading, setLoading] = useState(false)
    const [formError, setError] = useState(null)
    const [numCertsAndInstrucs, setNumCertsAndInstrucs] = useState({
        numCertifcates: 0,
        numInstructors: 0,
    })

    const hideError = () => {
        setError('');
    }

    const onChange = event => {
        setFormState({
            ...formState,
            [event.target.name]: event.target.value
        });
    }

    const onClear = (event) => {
        setFormState(initForm)
        setCertificates([])
        setError(null)
    }

    const onSearch = (event) => {
        // sessionStorage.setItem("certificateSearchState", JSON.stringify(state));
        refresh();
    }

    // when search is made
    const refresh = () => {
        setLoading(true)
        axios.get('/api/certificate/search', {
            params: {
                lastName: formState.lastName,
                firstName: formState.firstName,
                county: formState.county,
                city: formState.city,
                companyName: formState.companyName,
                fromDate: formState.fromDate,
                toDate: formState.toDate
            }
        }).then((res) => {
            //console.log(res.data.certificates);
            let enhancedData = [];
            enhancedData = res.data.certificates.map((certificate) => {
                let cert = JSON.parse(JSON.stringify(certificate))
                cert.Name = cert.LastName + ', ' + cert.FirstName + ' ' + (cert.MiddleName || "") + ' ' + (cert.Suffix || "");
                cert.TraineeCity = cert.TraineeCity || "-";
                cert.CompanyName = cert.CompanyName || "-";
                cert.County = cert.County || "-";
                return cert;
            });
            setCertificates(enhancedData)
            setLoading(false)
        }).catch(error => {
            console.log("error:" + error);
            setLoading(false)
            //setError(error.message)
        });
    }

    useEffect(() => {
        //on mount
        axios.get('/api/certificate/summary', {
        }).then((res) => {
            setNumCertsAndInstrucs({
                numCertifcates: res.data.noCertifcates.toLocaleString('en'),
                numInstructors: res.data.noInstructors.toLocaleString('en')
            });
        }).catch(error => {
            console.log("error:" + error);
            //setError(error.message)
        });
    }, [])


    const { classes } = props;

    if (formError) {
        return <div>
            <br />
            <Alert severity="error" onClose={hideError}>{formError}</Alert>
            <br />
        </div>
    }

    if (formError !== null) return <Error />;
    
    const headCells = [
        { id: 'Name', centered: false, sortable: true, label: 'Name' },
        { id: 'County', centered: false, sortable: true, label: 'County' },
        { id: 'TraineeCity', centered: false, sortable: true, label: 'City' },
        { id: 'CompanyName', centered: false, sortable: true, label: 'Company Name' },
        { id: 'CertDate', centered: false, sortable: true, label: 'Certified Date' },
    ];

    const bodyCells = [
        { id: 'Name', centered: false },
        { id: 'County', centered: false },
        { id: 'TraineeCity', centered: false },
        { id: 'CompanyName', centered: false },
        { id: 'CertDate', centered: false },
    ];

    const defaultSortKey = 'Name';
    const editDelete = false;

    return (
        <Fragment>
            <PageHeader
                title={"GI-BMP Training Certificate Search"}
            />
            <div>
                <div>
                    <Grid container justifyContent="center" spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Typography align="center" component="h3">
                                Certified Professionals
                            </Typography>
                            <Typography align="center" color="textSecondary" component="p">
                                {numCertsAndInstrucs.numCertifcates}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography align="center" component="h3">
                                Active Certified Instructors
                            </Typography>
                            <Typography align="center" variant="body2" color="textSecondary" component="p">
                                {numCertsAndInstrucs.numInstructors}
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <hr />
            <p>Please enter one or more search criteria</p>
            <div>
                <div >
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="firstName"
                                label="First Name"
                                type="text"
                                name='firstName'
                                value={formState.firstName}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="lastName"
                                label="Last Name"
                                type="text"
                                name='lastName'
                                value={formState.lastName}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="county"
                                label="County"
                                type="text"
                                name='county'
                                value={formState.county}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="city"
                                label="City"
                                type="text"
                                name='city'
                                value={formState.city}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="companyName"
                                label="Company Name"
                                type="text"
                                name='companyName'
                                value={formState.companyName}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="fromDate"
                                label="From"
                                type="date"
                                name='fromDate'
                                value={formState.fromDate}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="toDate"
                                label="To"
                                type="date"
                                name='toDate'
                                value={formState.toDate}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}  style={{ textAlign: "center" }}>
                            <Button variant="contained" color="primary" className={[].join(' ')} 
                            onClick={onSearch} >Search</Button>
                            <Button variant="contained" color="secondary" className={[].join(' ')} 
                            onClick={onClear} >Clear</Button>
                        </Grid>
                    </Grid>
                    <br />
                    {loading &&
                        <h1>Please wait – search in process</h1>
                    }

                    {!loading &&
                        <div>
                            <p>Found {certificates.length} records</p>
                            <br />
                            <SortedTable
                                data={certificates}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey={defaultSortKey}
                                cellKey={"id"}
                                // cellKey={"Trainee_ID"}
                                editDelete={editDelete}
                            />
                        </div>
                    }
                </div>
            </div>
        </Fragment>
    );

}

// export default Certificate;
export default withStyles(styles, { withTheme: true })(Certificate);
